import { computed } from 'vue'
import type { ComputedRef } from 'vue'
// types
import type { StrapiFooterInfoItem } from '@ts-strapi/interfaces'
// helpers
import dayjs from 'dayjs'

interface UseFooterBottomRowOptions {
  items: ComputedRef<StrapiFooterInfoItem[]>
}

interface UseFooterBottomRowReturn {
  refResolved: ComputedRef<StrapiFooterInfoItem[]>
  refLead: ComputedRef<StrapiFooterInfoItem | null>
  refRest: ComputedRef<StrapiFooterInfoItem[]>
}

export const useFooterBottomRow = (
  { items }: UseFooterBottomRowOptions,
): UseFooterBottomRowReturn => {
  const refResolved = computed<StrapiFooterInfoItem[]>(() => {
    const year = dayjs().year().toString()
    return items.value.map(item => ({
      ...item,
      text: item.text.replace('{year}', year),
    }))
  })

  const refLead = computed<StrapiFooterInfoItem | null>(
    () => refResolved.value[0] ?? null,
  )

  const refRest = computed<StrapiFooterInfoItem[]>(
    () => refResolved.value.slice(1),
  )

  return { refResolved, refLead, refRest }
}